import React, { useState, useEffect, useCallback } from "react";
import { setTitle } from "../helpers/MetaTag";
import Button from "../components/form/Button";
import TableSkeleton from "../components/loader/TableSkeleton";
import { Tooltip } from "react-tooltip";
import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import NoDataFound from "../components/NoDataFound";
import ManageSurveyQuestionPopup from "../components/popup/ManageSurveyQuestionPopup";
import toastr from "toastr";
//import DeletePopup from "../components/DeletePopup";

const BoardEffectivenessSettings = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Executive Audit Settings"
  );
  const { i18n, t } = useTranslation();
  const role = localStorage.getItem("role");
  const user = useSelector((state) => state.auth?.user);
  const [loading, setLoading] = useState(true);
  const [keyword, setKeyword] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [sortKey, setSortKey] = useState("created_at");
  const [sortValue, setSortValue] = useState(1);
  const [sortQuery, setSortQuery] = useState("");
  const [noOfPage, setNoOfPage] = useState(0);
  const [surveyData, setSurveyData] = useState([]);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [actionValue, setActionValue] = useState({});
  const [enabledPopup, setEnabledPopup] = useState({
    data: null,
    isOpen: false,
    id: null,
  });
  const [editData, setEditData] = useState({});
  const [loadingStatus, setLoadingStatus] = useState({});
  // const [enabledDeletePopup, setenabledDeletePopup] = useState(false);
  // const [currentId, setCurrentId] = useState("");

  useEffect(() => {
    if (sortKey && sortValue) {
      setSortQuery({ [sortKey]: sortValue });
    } else {
      setSortQuery("");
    }
  }, [sortKey, sortValue]);

  const loadList = useCallback(async () => {
    setLoading(true);
    try {
      const result = await postData("employee-rating-option/list", {
        keyword: keyword,
        //   limit: limit,
        //   offset: offset,
        sortQuery: { created_at: 1 },
        //status: 1,
        type: "boardmember",
      });
      if (result.data) {
        setSurveyData(result.data);
      }
      setTotalDataCount(result.count);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  }, [actionValue]);

  useEffect(() => {
    loadList();
  }, [loadList]);

  const handleStatusToggle = async (itemId, currentStatus) => {
    setLoadingStatus((prev) => ({ ...prev, [itemId]: true }));
    try {
      const statusData = await postData("employee-rating-option/status-change", {
        id: itemId,
        status: currentStatus,
      });

      if (statusData.data) {
        loadList();
      } else {
        toastr.error(statusData.message);
      }
    } catch (error) {
      toastr.error(error.message);
    } finally {
      setLoadingStatus((prev) => ({ ...prev, [itemId]: false }));
    }
  };

  // useEffect(() => {
  //   const loadDeleteRecord = async () => {
  //     try {
  //       const statusData = await postData("employee-rating-option/delete", {
  //         id: actionValue?.row_id,
  //       });
  //       if (statusData.status === 200) {
  //         setSurveyData((survey) =>
  //           survey.filter((item) => item._id !== actionValue.row_id)
  //         );
  //       } else {
  //         toastr.error(statusData.message);
  //       }
  //     } catch (error) {
  //       toastr.error(error.message);
  //     }
  //   };
  //   if (actionValue && actionValue.button_type === "delete") {
  //     loadDeleteRecord();
  //   }
  // }, [actionValue]);

  return (
    <>
      <div className="relative flex justify-between items-center mb-6 flex-wrap sm:flex-nowrap gap-y-4">
        <div className="text-xl md:text-3xl text-slate-800 font-bold">
          {t("board_effectiveness_settings") + " - " + user?.company_name}
        </div>
      </div>

      <div className="w-full bg-white rounded-xl shadow-lg border border-slate-200 min-h-[480px]">
        <table className="w-full table-fixed">
          <thead>
            <tr className="text-white font-semibold text-sm leading-none border-b border-slate-300">
              <th className="py-5 px-6 text-left sticky -top-6 z-10 bg-gradient-to-r from-slate-800 to-slate-900 rounded-tl-xl">
                {t("name")}
              </th>
              <th className="py-5 px-6 text-center w-40 sticky -top-6 z-10 bg-gradient-to-r from-slate-800 to-slate-900">
                {t("status")}
              </th>
              <th className="py-5 px-6 w-40 sticky text-right -top-6 z-10 bg-gradient-to-r from-slate-800 to-slate-900 rounded-tr-xl">
                {t("action")}
              </th>
            </tr>
          </thead>
          <tbody className="text-slate-700 text-sm font-medium bg-white">
            {totalDataCount > 0 ? (
              surveyData.map((item, index) => (
                <tr 
                  className="border-b border-slate-100 hover:bg-slate-50 transition-colors duration-200" 
                  key={index}
                >
                  <td className="py-4 px-6 text-left">
                    <div className="block">
                      <div className="text-sm font-semibold text-slate-700 mb-1 break-words">
                        {item?.question?.name}
                      </div>
                      <div className="text-xs text-slate-500 leading-relaxed break-words">
                        {item?.question?.description}
                      </div>
                    </div>
                  </td>
                  
                  <td className="py-4 px-6 text-center w-40">
                    <div className="flex justify-center">
                      <label className="relative inline-flex items-center cursor-pointer">
                        {/* Clickable status label */}
                        <span
                          onClick={() =>
                            handleStatusToggle(item?._id, item?.status === 1 ? 2 : 1)
                          }
                          className={`px-3 py-1 rounded-full text-xs font-medium cursor-pointer flex items-center justify-center space-x-1 ${
                            item?.status === 1
                              ? 'bg-teal-200 text-teal-800 hover:bg-teal-300'
                              : 'bg-rose-200 text-rose-800 hover:bg-rose-300'
                          } transition duration-200 ease-in-out`}
                        >
                          {/* FontAwesome Icon */}
                          {loadingStatus[item?._id] ? (
                            <i className="fa fa-spinner fa-spin text-sm" />
                          ) : item?.status === 1 ? (
                            <i className="fa-fw fa-regular fa-check text-sm" />
                          ) : (
                            <i className="fa-fw fa-regular fa-times text-sm" />
                          )}
                          {/* Status Text */}
                          <span>{item?.status === 1 ? t('active') : t('inactive')}</span>
                        </span>
                      </label>
                    </div>
                  </td>
                  
                  <td className="py-4 px-6 text-left w-40">
                    <div className="flex items-center space-x-2 justify-end">
                      <div
                        className="relative"
                        data-tooltip-id={`editButton${item?._id}`}
                        data-tooltip-place="top"
                      >
                        <Button
                          buttonClasses={
                            "!p-2 !flex !items-center !justify-center !text-xs !bg-teal-50 hover:!bg-teal-100 !text-teal-600 hover:!text-teal-700 !w-8 !h-8 !rounded !border !border-teal-200 hover:!border-teal-300 !transition-all !duration-200"
                          }
                          buttonType={"button"}
                          buttonIcon={"fa-regular fa-pencil"}
                          buttonIconPosition={"left"}
                          buttonHasLink={false}
                          functions={() => {
                            setEnabledPopup({
                              id: item?._id,
                              data: item,
                              isOpen: true,
                            });
                          }}
                        />
                        <Tooltip
                          id={`editButton${item?._id}`}
                          className="!text-xs !bg-slate-800 z-50 rounded py-1 px-2 !shadow-lg"
                          render={() => (
                            <div className="text-white">
                              <div className="text-xs font-medium">
                                {t('edit_settings')}
                              </div>
                            </div>
                          )}
                        />
                      </div>
                      
                      {/* <div
                        className="relative"
                        data-tooltip-id={`deleteButton${item?._id}`}
                        data-tooltip-place="top"
                      >
                        <Button
                          buttonClasses={
                            "!p-2 !flex !items-center !justify-center !text-xs !bg-rose-50 hover:!bg-rose-100 !text-rose-600 hover:!text-rose-700 !w-8 !h-8 !rounded !border !border-rose-200 hover:!border-rose-300 !transition-all !duration-200"
                          }
                          buttonType={"button"}
                          buttonIcon={"fa-regular fa-trash"}
                          buttonIconPosition={"left"}
                          buttonHasLink={false}
                          functions={() => {
                            setenabledDeletePopup(true);
                            setCurrentId(item?._id);
                          }}
                        />
                        <Tooltip
                          id={`deleteButton${item?._id}`}
                          className="!text-xs !bg-slate-800 z-50 rounded py-1 px-2 !shadow-lg"
                          render={() => (
                            <div className="text-white">
                              <div className="text-xs font-medium">
                                {t('delete')}
                              </div>
                            </div>
                          )}
                        />
                      </div> */}

                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="border-b border-slate-100">
                <td className="py-8 px-6 text-center" colSpan={3}>
                  {loading ? (
                    <TableSkeleton tableImage={false} />
                  ) : (
                    <div className="flex flex-col items-center justify-center space-y-3">
                      <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center">
                        <i className="fa-regular fa-inbox text-2xl text-slate-400"></i>
                      </div>
                      <NoDataFound label={t("no_data_found")} />
                    </div>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {enabledPopup?.isOpen && (
        <ManageSurveyQuestionPopup
          isOpen={enabledPopup?.isOpen}
          setIsOpen={setEnabledPopup}
          data={enabledPopup?.data}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
          type={"boardmember"}
          id={enabledPopup?.id}
          loadList={loadList}
        />
      )}
      {/* {enabledDeletePopup && (
        <DeletePopup
          isOpen={enabledDeletePopup}
          setIsOpen={(val) => setenabledDeletePopup(val)}
          currentId={currentId}
          getActionValue={(obj) => {
            setActionValue(obj);
            setenabledDeletePopup(false);
            setCurrentId("");
          }}
        />
      )} */}
    </>
  );
};

export default BoardEffectivenessSettings;
